export const translateTypeProperty = (type: string): string => {
	const normalized = type.trim().toLowerCase();

	switch (normalized) {
		case "residencial":
			return "residential";
		case "comercial":
			return "commercial";
		case "misto":
			return "mixed";
		default:
			return "residential"; // fallback seguro
	}
};
